import React, {useEffect, useMemo, useState} from 'react';
import {isMobile} from 'react-device-detect';
import Header from '~/components/Header';
import MobileHeader from '~/components/MobileHeader/index';
import {getLandingConfig} from '~/utils/tools';
import {versionDropdown} from '~/Configuration/themeConfig';

const ThemeHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [pageSize, setPageSize] = useState({
    width: document.querySelector('.enos-doc')?.offsetWidth
  });
  const [curDocName, setCurDocName] = useState('');
  const [menuVisible, setMenuVisible] = useState(false);
  const {
    language = '',
    // docUrl = '',
    // g_url: gUrl = '',
    versions = [],
    currentVersion = ''
  } = window.sphinxEnosThemeHeader || {};

  const curVersion = useMemo(() => (currentVersion === 'dev' ? 'preview' : currentVersion), [currentVersion]);
  let lanKey = 'zh_CN';
  if (language === 'en' || language === 'en_us' || language === 'en_US' || language === 'EN_US') {
    lanKey = 'en';
  } else {
    lanKey = 'zh_CN';
  }
  const landingConfig = getLandingConfig(lanKey);
  const handleClick = () => {
    const pathName = window.location.pathname;
    const r = /\/(zh_CN|en)\/((\d+.\d+.\d+)|dev|stable|preview|master|latest)\//g; // Optimization is needed here,
    if (pathName.match(r)) {
      window.location.href = `${window.location.origin}/docs${pathName.match(r)[0]}`;
    }
  };

  const docTitle = document.getElementsByClassName('breadcrumbs')[0];
  const docHome = docTitle.getElementsByClassName('home_docs')[0];
  if (docHome) {
    docHome.onclick = handleClick;
  }

  const versionsList = useMemo(() => {
    const pathName = window.location.pathname;
    const repo = pathName.match(/\/docs\/(\S+)\/(zh_CN|en)\//)?.[1];
    const lan = pathName.match(/\/docs\/(\S+)\/(zh_CN|en)\//)?.[2];
    if (versionDropdown?.[repo] && versionDropdown?.[repo]?.[lan] && Array.isArray(versionDropdown?.[repo]?.[lan])) {
      return versionDropdown[repo][lan].map((v) => v);
    }
    return versions.map((v) => v.split('/')[2]);
  }, [versionDropdown, versions]);

  useEffect(() => {
    const docName = document.querySelector('.enos-doc .enos-doc-toc .product-name');
    if (docName) {
      setCurDocName(docName?.innerText);
    }
    const listenerResize = () => {
      const root = document.querySelector('.enos-doc');
      if (root) {
        setPageSize({
          width: root.offsetWidth
        });
      }
    };
    const listenerScroll = () => {
      const scrollX = window.scrollX;
      const newTitle = document.querySelector('.new-title.theme');
      if (newTitle) {
        newTitle.style.transform = `translateX(-${scrollX}px)`;
      }
    };
    window.addEventListener('resize', listenerResize);
    window.addEventListener('scroll', listenerScroll);
    return () => {
      window.removeEventListener('resize', listenerResize);
      window.removeEventListener('scroll', listenerScroll);
    };
  }, []);

  useEffect(() => {
    if (isMobile) {
      document.querySelector('.enos-doc').classList.remove('is-web');
      document.querySelector('.enos-doc').classList.add('is-mobile');
    } else {
      document.querySelector('.enos-doc').classList.remove('is-mobile');
      document.querySelector('.enos-doc').classList.add('is-web');
    }
  }, [isMobile]);

  useEffect(() => {
    const docSide = document.querySelector('.enos-doc-side');
    const docSideScroll = document.querySelector('.enos-doc-side .enos-doc-side-scroll');
    const toc = document.querySelector('.enos-doc-side .enos-doc-side-scroll .enos-doc-toc');
    const sideBanner = document.querySelector('.enos-doc-side .banner');
    const root = document.querySelector('#root');
    if (docSide && docSideScroll && toc && sideBanner && root) {
      if (menuVisible && window.innerWidth <= 960) {
        docSide.style.display = 'block';
        docSide.style.flex = `0 0 ${isMobile ? '100vw' : `${pageSize.width}px`}`;
        docSideScroll.style.width = '100%';
        docSideScroll.style.position = 'static';
        toc.style.width = '100%';
        sideBanner.style.width = '100%';
        root.style.overflowY = 'hidden';
      } else {
        docSide.style = '';
        docSideScroll.style = '';
        docSideScroll.style.position = 'fixed';
        toc.style = '';
        sideBanner.style = '';
        root.style = '';
      }
    }
  }, [menuVisible, pageSize.width, isMobile]);

  return (
    <>
      {isMobile ? (
        <MobileHeader
          insertTheme
          locale={lanKey}
          version={curVersion}
          menuOpen={menuOpen}
          setMenuOpen={setMenuOpen}
          isTutorial={false}
          configData={landingConfig?.[curVersion]?.header || []}
          versionKeys={versionsList}
        />
      ) : (
        <Header
          insertTheme
          locale={lanKey}
          version={curVersion}
          pageSize={pageSize}
          isTutorial={false}
          configData={landingConfig?.[curVersion]?.header || []}
          versionKeys={versionsList}
          isLanding={false}
        />
      )}
      <div
        className={`new-title theme ${isMobile ? 'is-mobile' : 'is-web'}`}
        style={{width: `${pageSize.width}px`}}
      >
        <div
          className='new-title-icon-wrapper'
          onClick={() => setMenuVisible(!menuVisible)}
        >
          {menuVisible ? <i className='dpl20_wrong_s' /> : <img src={require('~/assets/images/header/menu.svg')} alt='menu' />}
        </div>
        <div className='new-title-name'>{curDocName}</div>
      </div>
    </>
  );
};

export default ThemeHeader;
